itsoftApp.createModule("uteka", function () {
    var module = this;

    var initUteka = function() {
        window.uteka.onReady(function () {
            var widget = document.querySelector('.uteka-widget')

            window.uteka.loadWidget(widget, {
                productId: widget.getAttribute("data-id") || null,
                productIds: [
                ]
            })
        });
    }

    module.callback = initUteka;
});